<template>
  <div
    class="m-content-editor-primary"
    spellcheck="false"
  >
    <div class="m-content-editor-primary-menu">
      <form
        name="html-edition"
        class="display-flex-row-center"
      >
        <button
          v-for="(button, index) in menuButtons"
          :key="`btn-editor-${index}`"
          :class="['a-tooltip-primary a-tooltip-bottom menu-button-action', button.class]"
          :data-tooltip-text="button.name"
          :disabled="buttonPrimary.sending"
          @click.prevent="insertBlock(button.blockType)"
        >
          <i :class="button.icon"></i>
        </button>

        <button
          class="a-tooltip-primary a-tooltip-bottom menu-button-action menu-button-action-image"
          data-tooltip-text="Imagen"
          :disabled="buttonPrimary.sending"
          @click.prevent="insertImage"
        >
          <i class="far fa-file-image"></i>
        </button>

        <input
          id="files"
          class="inputFileHidden"
          name="files"
          ref="files"
          type="file"
          @change.prevent="handleFile"
        />

        <button
          class="a-tooltip-primary a-tooltip-bottom menu-button-action menu-button-action-document"
          data-tooltip-text="Documento"
          :disabled="buttonPrimary.sending"
          @click.prevent="insertFile"
        >
          <i class="far fa-file-alt"></i>
        </button>

        <input
          id="images"
          class="inputImageHidden"
          name="images"
          ref="images"
          type="file"
          @change.prevent="handleImage"
        />

        <span v-show="element.tipo === 1">
          <div class="m-dropdown-primary">
            <a
              :class="['a-tooltip-primary a-tooltip-bottom menu-button-action menu-button-action-icon',
                       buttonPrimary.sending ? 'menu-button-action-icon-disabled' : '', 'display-flex-row-center justify-content-center']"
              data-tooltip-text="Icono"
              @click.stop="$dropDown.switchDropDown('MoleculeContentEditorDropDownIcons')"
              style="display: flex; margin: 0"
            >
              <i class="far fa-icons"></i>
            </a>
            <MoleculeContentEditorDropDownIcons
              :selected-icon="datos.nodo.icono"
              @handleIcon="handleIcon"
              @removeIcon="removeIcon"
            />
          </div>
        </span>

        <span
          v-show="element.tipo === 1 && isPath"
          class="colorPickerWrapper"
        >
          <button
            class="a-tooltip-primary a-tooltip-bottom menu-button-action menu-button-action-color"
            data-tooltip-text="Color de Fondo"
            :disabled="buttonPrimary.sending"
            @click.prevent="insertColor"
          >
            <i
              id ="color-picker-icon"
              class="fas fa-circle icon-border"
              :style="`color: ${datos.nodo.color}`"
            >
            </i>
          </button>
          <input
            v-model="datos.nodo.color"
            id="color"
            class="inputColorHidden"
            name="color"
            ref="color"
            type="color"
            @input.prevent="handleColor"
          />
        </span>

        <span
          v-show="element.tipo === 1 && isPath"
          class="colorTextPickerWrapper"
        >
          <button
            class="a-tooltip-primary a-tooltip-bottom menu-button-action justify-content-center display-flex-row-center"
            data-tooltip-text="Color del Nombre"
            :disabled="buttonPrimary.sending"
            @click.prevent="insertColorText"
            :style="`background-color: ${datos.nodo.color}; border: 0; border-radius: var(--radius-small); box-shadow: var(--color-black) 0px 0px 2px; display: flex; height: 20px; padding: 0 !important;`"
          >
            <i
              class="far fa-font"
              :style="`color: ${datos.nodo.color_nombre}; font-size: 14px;`"
            >
            </i>
          </button>
          <input
            v-model="datos.nodo.color_nombre"
            id="colorNombre"
            class="inputColorHidden"
            name="colorNombre"
            ref="colorNombre"
            type="color"
            @input.prevent="handleColorNombre"
          />
        </span>
      </form>

      <form
        autocomplete="off"
        class="menu-button-action-save"
        name="editor-form"
        @submit.prevent="setContenidoNodoTarea"
      >
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.cancelChanges"
          :disabled="buttonPrimary.sending"
          :element="datos"
          @resetEditor="resetEditor"
        />
        <AtomButtonPrimary
          :button-primary="buttonPrimary"
          :disabled="buttonPrimary.sending"
        />
      </form>
    </div>

    <draggable
      :animation="0"
      :list="currentHtml.blocks"
      :class="['m-content-editor-primary-html', buttonPrimary.sending  ? 'm-content-editor-primary-html-disabled' : '']"
      :disabled="buttonPrimary.sending"
      draggable=".sortable-item"
      fallback-class="display-none"
      :force-fallback="true"
      group="sortable-item"
      :pull="false"
      :scroll="true"
      :scroll-sensitivity="200"
      tag="div"
    >
      <Block
        v-for="(block, index) in currentHtml.blocks"
        :key="block.id"
        :is="`MoleculeContentEditorBlock${block.type}`"
        :can-edit="!buttonPrimary.sending"
        :block="block"
        :index="index"
        :time="currentHtml.time"
        @deleteBlock="deleteBlock"
        @insertAudio="insertAudio"
        @insertLink="insertLink"
        @insertVideo="insertVideo"
        @updateText="updateText"
      />
    </draggable>

    <div
      :class="['m-content-editor-primary-task', { 'm-content-editor-primary-task-disabled': buttonPrimary.sending }]"
      v-show="element.tipo === 1 && !isPath"
    >
      <div class="m-content-editor-primary-task-config">
        <div class="m-container-primary">
          <div class="row">
            <div class="column column-6">
              <label class="a-checkbox-primary">
                <input
                  v-model="currentTask.archivos"
                  class="a-checkbox-input-maps-primary"
                  :disabled="buttonPrimary.sending"
                  name="tarea_archivos"
                  type="checkbox"
                />
                <span class="a-checkbox-checkmark"></span>
                <span>El alumno puede adjuntar archivos</span>
              </label>
              <label class="a-checkbox-primary">
                <input
                  v-model="currentTask.videos"
                  class="a-checkbox-input-maps-primary"
                  :disabled="buttonPrimary.sending"
                  name="tarea_archivos"
                  type="checkbox"
                />
                <span class="a-checkbox-checkmark"></span>
                <span>El alumno puede adjuntar un video</span>
              </label>
            </div>
            <div class="column column-6">
              <label class="a-input-wrapper-row">
                <input
                  v-model="currentTask.dia_entrega"
                  class="a-input-primary"
                  :disabled="buttonPrimary.sending"
                  min="0"
                  name="dia_entrega"
                  type="number"
                >
                <span>
                  <i class="fas fa-shoe-prints fa-rotate-270"></i>
                  Días para cumplir objetivos
                </span>
              </label>
              <label class="a-input-wrapper-row">
                <input
                  v-model="currentTask.cumplido"
                  class="a-input-primary"
                  :disabled="buttonPrimary.sending || currentTask.dia_entrega === 0"
                  :min="currentTask.no_cumplido + 1"
                  name="cumplido"
                  type="number"
                >
                <span>
                  <i class="fas fa-star text-color-notifications-primary"></i>
                  Ganadas a tiempo
                </span>
              </label>
              <label class="a-input-wrapper-row">
                <input
                  v-model="currentTask.no_cumplido"
                  class="a-input-primary"
                  :disabled="buttonPrimary.sending || currentTask.dia_entrega === 0 ||
                    currentTask.cumplido === 0"
                  :max="currentTask.cumplido - 1"
                  min="0"
                  name="no_cumplido"
                  type="number"
                >
                <span>
                  <i class="fas fa-star text-color-notifications-primary"></i>
                  Fuera de tiempo
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="toScroll"></div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'MoleculeContentEditor',

  components: {
    draggable,
    MoleculeContentEditorBlockAudio: () => import('@/components/molecules/MoleculeContentEditorBlockAudio'),
    MoleculeContentEditorBlockDocument: () => import('@/components/molecules/MoleculeContentEditorBlockDocument'),
    MoleculeContentEditorBlockIframeVideo: () => import('@/components/molecules/MoleculeContentEditorBlockIframeVideo'),
    MoleculeContentEditorBlockImage: () => import('@/components/molecules/MoleculeContentEditorBlockImage'),
    MoleculeContentEditorBlockInputAudio: () => import('@/components/molecules/MoleculeContentEditorBlockInputAudio'),
    MoleculeContentEditorBlockInputLink: () => import('@/components/molecules/MoleculeContentEditorBlockInputLink'),
    MoleculeContentEditorBlockInputVideo: () => import('@/components/molecules/MoleculeContentEditorBlockInputVideo'),
    MoleculeContentEditorBlockLink: () => import('@/components/molecules/MoleculeContentEditorBlockLink'),
    MoleculeContentEditorBlockParagraph: () => import('@/components/molecules/MoleculeContentEditorBlockParagraph'),
    MoleculeContentEditorBlockTitle1: () => import('@/components/molecules/MoleculeContentEditorBlockTitle1'),
    MoleculeContentEditorDropDownIcons: () => import('@/components/molecules/MoleculeContentEditorDropDownIcons')
  },

  props: {
    element: {
      type: Object,
      default: () => ({ tipo: 0 })
    },

    nodos: {
      type: Array,
      default: () => ([])
    }
  },

  data () {
    return {
      blocks: [
        {
          type: 'Audio',
          data:
            {
              url: ''
            }
        },

        {
          type: 'Document',
          data:
            {
              file: '',
              name: ''
            }
        },

        {
          type: 'Image',
          data:
            {
              file: '',
              name: ''
            }
        },

        {
          type: 'IframeVideo',
          data:
            {
              embed: '',
              url: ''
            }
        },

        {
          type: 'InputAudio',
          data:
            {
              url: ''
            }
        },

        {
          type: 'InputLink',
          data:
            {
              url: ''
            }
        },

        {
          type: 'InputVideo',
          data:
            {
              url: ''
            }
        },

        {
          type: 'Link',
          data:
            {
              url: ''
            }
        },

        {
          type: 'Paragraph',
          data:
            {
              text: ''
            }
        },

        {
          type: 'Title1',
          data:
            {
              text: ''
            }
        },

        {
          type: 'Title2',
          data:
            {
              text: ''
            }
        },

        {
          type: 'Title3',
          data:
            {
              text: ''
            }
        },

        {
          type: 'Title4',
          data:
            {
              text: ''
            }
        },

        {
          type: 'Title5',
          data:
            {
              text: ''
            }
        },

        {
          type: 'Title6',
          data:
            {
              text: ''
            }
        }
      ],

      buttonPrimary: {
        action: this.$t('mContentEditor.buttonPrimary'),
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        cancelChanges: {
          class: 'a-button-secondary a-button-reset-secondary display-flex-row-center margin-right-small',
          component: '',
          icon: 'far fa-times',
          method: 'resetEditor',
          text: 'Cancelar',
          type: 'button'
        }
      },

      currentHtml: {
        time: 0,

        blocks: []
      },

      currentTask: {
        archivos: false,
        cumplido: 0,
        dia_entrega: 0,
        no_cumplido: 0,
        videos: false
      },

      datos: {
        academia: 0,

        nodo: {
          color: '#ffffff',
          color_nombre: '#5d5d5d',
          icono: '',
          nombre: '',
          titulo: ''
        },

        texto: ''
      },

      defaultHtml: {
        time: 0,

        blocks: [
          {
            type: 'Title1',
            data:
              {
                text: ''
              }
          },

          {
            type: 'Paragraph',
            data:
              {
                text: ''
              }
          },

          {
            type: 'InputVideo',
            data:
              {
                url: ''
              }
          }
        ]
      },

      defaultTask: {
        archivos: false,
        cumplido: 0,
        dia_entrega: 0,
        no_cumplido: 0,
        videos: false
      },

      isFileExtensionValid: true,
      isFileSizeValid: true,
      isPath: false,

      menuButtons: [
        {
          blockType: 'Title1',
          class: 'menu-button-action-title',
          icon: 'far fa-heading',
          name: 'Título'
        },

        {
          blockType: 'Paragraph',
          class: 'menu-button-action-paragraph',
          icon: 'far fa-paragraph',
          name: 'Párrafo'
        },

        {
          blockType: 'InputVideo',
          class: 'menu-button-action-video',
          icon: 'far fa-play',
          name: 'Video'
        },

        {
          blockType: 'InputAudio',
          class: 'menu-button-action-audio',
          icon: 'far fa-volume-up',
          name: 'Audio'
        },

        {
          blockType: 'InputLink',
          class: 'menu-button-action-link',
          icon: 'far fa-link',
          name: 'Enlace'
        }
      ]
    }
  },

  computed: {
    nodo () {
      return Object.assign({}, this.$store.getters.getAssetSelectedNode)
    }
  },

  watch: {
    'currentTask.dia_entrega' () {
      this.currentTask.dia_entrega = Math.abs(this.currentTask.dia_entrega)
      if (this.currentTask.dia_entrega === 0) {
        this.currentTask.cumplido = 0
        this.currentTask.no_cumplido = 0
      }
    },

    'currentTask.cumplido' () {
      this.currentTask.cumplido = Math.abs(this.currentTask.cumplido)
      if (this.currentTask.cumplido === 0) {
        this.currentTask.no_cumplido = 0
      }
    },

    'currentTask.no_cumplido' () {
      this.currentTask.no_cumplido = Math.abs(this.currentTask.no_cumplido)
    },

    nodo () {
      this.setPathState()
      this.setCurrentHtml(false)
      this.setCurrentTask()
    },

    nodos () {
      this.setPathState()
    }
  },

  created () {
    this.datos.academia = this.$store.getters.getAcademyData.id
    this.setPathState()
    this.setCurrentHtml(false)
    this.setCurrentTask()
  },

  methods: {
    createContenidoNodoTarea (taskParams) {
      this.$services.create('contenido', 'createContenidoNodoTarea', taskParams,
        [this.$store.getters.getAssetSelectedNode.id])
        .then(response => {
          this.updateContenidoNodo()
        })
        .catch(error => {
          console.log(error)
          this.updateContenidoNodo()
        })
    },

    deleteBlock (index) {
      // TODO: preguntar si está seguro de eliminar el bloque
      this.currentHtml.blocks.splice(index, 1)
    },

    handleColor (event) {
      this.datos.nodo.color = event.target.value
      let selectedNode = Object.assign({}, this.$store.getters.getAssetSelectedNode)
      this.$store.commit('setEditorPickedColor', { color: event.target.value,
        id: selectedNode.id })
    },

    handleColorNombre (event) {
      this.datos.nodo.color_nombre = event.target.value
      let selectedNode = Object.assign({}, this.$store.getters.getAssetSelectedNode)
      this.$store.commit('setEditorPickedColorNombre', { colorNombre: event.target.value,
        id: selectedNode.id })
    },

    handleIcon (icon) {
      this.datos.nodo.icono = icon
      let selectedNode = Object.assign({}, this.$store.getters.getAssetSelectedNode)
      this.$store.commit('setEditorPickedIcon', { icon: icon, id: selectedNode.id })
    },

    handleImage (event) {
      let input = event.target
      this.isFileExtensionValid = this.$files.allowedFileExtension(input.files[0].name, 'image')
      this.isFileSizeValid = this.$files.allowedFileSize(input.files[0].size)
      if (input.files && input.files[0] && this.isFileExtensionValid && this.isFileSizeValid) {
        let newImage = JSON.parse(JSON.stringify(this.blocks.find(block => block.type === 'Image')))
        var reader = new FileReader()
        reader.onload = (e) => {
          newImage.data.file = e.target.result
          newImage.data.name = input.files[0].name
          document.querySelector(`input[name='images']`).value = ''
        }
        reader.readAsDataURL(input.files[0])
        this.currentHtml.blocks.push(newImage)
        window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight)
      } else if (!this.isFileExtensionValid) {
        this.$modal.showModal('MoleculeContentEditorModalImageExtensionError')
      } else if (!this.isFileSizeValid) {
        this.$modal.showModal('MoleculeContentEditorModalFileSizeError')
      }
    },

    handleFile (event) {
      let input = event.target
      this.isFileExtensionValid = this.$files.allowedFileExtension(input.files[0].name, 'document')
      this.isFileSizeValid = this.$files.allowedFileSize(input.files[0].size)
      if (input.files && input.files[0] && this.isFileExtensionValid && this.isFileSizeValid) {
        let newDocument = JSON.parse(JSON.stringify(this.blocks.find(block => block.type === 'Document')))
        var reader = new FileReader()
        reader.onload = (e) => {
          newDocument.data.file = e.target.result
          newDocument.data.name = input.files[0].name
          document.querySelector(`input[name='files']`).value = ''
        }
        reader.readAsDataURL(input.files[0])
        this.currentHtml.blocks.push(newDocument)
        window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight)
      } else if (!this.isFileExtensionValid) {
        this.$modal.showModal('MoleculeContentEditorModalFileExtensionError')
      } else if (!this.isFileSizeValid) {
        this.$modal.showModal('MoleculeContentEditorModalFileSizeError')
      }
    },

    insertBlock (type) {
      let newBlock = this.blocks.find(block => block.type === type)
      newBlock.id = `block-${Math.floor(Math.random() * 1000)}`
      this.currentHtml.blocks.push(JSON.parse(JSON.stringify(newBlock)))
      document.getElementById('toScroll').scrollIntoView({ block: 'center', behavior: 'smooth' })
    },

    insertColor () {
      document.getElementById('color').click()
    },

    insertColorText () {
      document.getElementById('colorNombre').click()
    },

    insertImage () {
      document.getElementById('images').click()
    },

    insertFile () {
      document.getElementById('files').click()
    },

    insertAudio (urlAudio, index) {
      let newAudio = JSON.parse(JSON.stringify(this.blocks.find(block => block.type === 'Audio')))
      newAudio.data.url = urlAudio
      this.currentHtml.blocks.splice(index, 1, newAudio)
    },

    insertLink (urlLink, index) {
      let newLink = JSON.parse(JSON.stringify(this.blocks.find(block => block.type === 'Link')))
      newLink.data.url = urlLink
      this.currentHtml.blocks.splice(index, 1, newLink)
    },

    insertVideo (embedVideo, urlVideo, index) {
      let newIframeVideo = JSON.parse(JSON.stringify(this.blocks.find(block => block.type === 'IframeVideo')))
      // guardo url original
      newIframeVideo.data.url = urlVideo
      // convierto url a embed -> https://www.youtube.com/embed/-wqqctEYyJM
      newIframeVideo.data.embed = embedVideo
      this.currentHtml.blocks.splice(index, 1, newIframeVideo)
    },

    removeIcon () {
      let selectedNode = Object.assign({}, this.$store.getters.getAssetSelectedNode)
      this.$store.commit('setEditorPickedIcon', { icon: '', id: selectedNode.id })
      this.datos.nodo.icono = ''
    },

    resetEditor () {
      this.setCurrentHtml(true)
      this.setCurrentTask()
    },

    setContenidoNodoTarea () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        if (this.element.tipo === 1 && !this.isPath) {
          if (this.currentTask.dia_entrega > 0 && this.currentTask.cumplido > 0) {
            this.currentTask.no_cumplido = this.currentTask.cumplido > 0 &&
              this.currentTask.no_cumplido >= this.currentTask.cumplido
              ? this.currentTask.cumplido - 1
              : this.currentTask.no_cumplido
            this.currentTask.cumplido = this.currentTask.no_cumplido > 0 &&
              this.currentTask.cumplido <= this.currentTask.no_cumplido
              ? this.currentTask.no_cumplido + 1
              : this.currentTask.cumplido
          }
          let taskParams = {
            proyecto: this.$route.params.id,
            tarea: Object.assign({}, this.currentTask)
          }
          taskParams.tarea.archivos = +taskParams.tarea.archivos
          taskParams.tarea.videos = +taskParams.tarea.videos
          if (this.$store.getters.getAssetSelectedNode.tarea) {
            this.updateContenidoNodoTarea(taskParams)
          } else {
            this.createContenidoNodoTarea(taskParams)
          }
        } else {
          this.currentTask = Object.assign({}, this.defaultTask)
          this.updateContenidoNodo()
        }
      }
    },

    setCurrentHtml (resetPickedColor) {
      this.currentHtml = this.$store.getters.getAssetSelectedNode.texto
        ? Object.assign({}, JSON.parse(this.$store.getters.getAssetSelectedNode.texto))
        : Object.assign({}, this.defaultHtml)

      this.currentHtml.blocks = [...this.currentHtml.blocks]

      this.currentHtml.blocks.forEach((block, i) => {
        this.currentHtml.blocks[i] = Object.assign({}, block)
        this.currentHtml.blocks[i].data = Object.assign({}, block.data)
        this.currentHtml.blocks[i].id = `block-${new Date().getTime() + i}`
      })

      let selectedNode = Object.assign({}, this.$store.getters.getAssetSelectedNode)

      this.datos.nodo.color = selectedNode.color
        ? selectedNode.color
        : '#ffffff'
      this.datos.nodo.color_nombre = selectedNode.colorNombre
        ? selectedNode.colorNombre
        : '#5d5d5d'
      this.datos.nodo.icono = selectedNode.icono
        ? selectedNode.icono
        : ''
      this.datos.nodo.nombre = selectedNode.nombre
      this.datos.nodo.titulo = selectedNode.titulo

      if (resetPickedColor) {
        this.$store.commit('setEditorPickedIcon', {
          icon: selectedNode.icono,
          id: selectedNode.id
        })

        if (this.isPath) {
          this.$store.commit('setEditorPickedColor', {
            color: selectedNode.color,
            id: selectedNode.id
          })
          this.$store.commit('setEditorPickedColorNombre', {
            colorNombre: selectedNode.colorNombre ? selectedNode.colorNombre : '#5d5d5d',
            id: selectedNode.id
          })
        }
      }
    },

    setCurrentTask () {
      let nodeTask = Object.assign({},
        this.$store.getters.getAssetSelectedNode.tarea)
      if (nodeTask) {
        this.currentTask = {
          archivos: nodeTask.archivos ? nodeTask.archivos : false,
          cumplido: nodeTask.cumplido ? nodeTask.cumplido : 0,
          dia_entrega: nodeTask.diaEntrega
            ? nodeTask.diaEntrega
            : nodeTask.dia_entrega
              ? nodeTask.dia_entrega
              : 0,
          no_cumplido: nodeTask.noCumplido
            ? nodeTask.noCumplido
            : nodeTask.no_cumplido
              ? nodeTask.no_cumplido
              : 0,
          videos: nodeTask.videos ? nodeTask.videos : false
        }
      } else {
        this.currentTask = Object.assign({}, this.defaultTask)
      }
    },

    setPathState () {
      this.isPath = this.nodos.findIndex(nodo =>
        nodo.id === this.nodo.id) !== -1
    },

    updateContenidoNodo () {
      this.currentHtml.blocks = this.currentHtml.blocks.filter(block =>
        block.type !== 'InputAudio' &&
        block.type !== 'InputLink' &&
        block.type !== 'InputVideo')
      this.currentHtml.time = Date.now()
      this.datos.texto = JSON.stringify(this.currentHtml)

      if (this.buttonPrimary.sending) {
        this.$services.update('contenido', 'updateContenidoNodo', this.datos,
          [this.$store.getters.getAssetContents[0].id, this.$store.getters.getAssetSelectedNode.id])
          .then(response => {
            this.$modal.updateData('readElement')
            let updatedNode = Object.assign({}, response.data)
            updatedNode.children = []
            if (updatedNode.color_nombre) {
              this.$set(updatedNode, 'colorNombre', updatedNode.color_nombre)
            }
            this.$store.commit('setAssetSelectedNode', updatedNode)
            this.$alerts.pushAlert('mContentEditor', 'updateContenidoNodo', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mContentEditor', 'updateContenidoNodo', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    },

    updateContenidoNodoTarea (taskParams) {
      this.$services.update('contenido', 'updateContenidoNodoTarea', taskParams,
        [this.$store.getters.getAssetSelectedNode.id])
        .then(response => {
          this.updateContenidoNodo()
        })
        .catch(error => {
          console.log(error)
          this.updateContenidoNodo()
        })
    },

    updateText (index, newText) {
      this.currentHtml.blocks[index].data.text = newText
    }
  }
}
</script>
